import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';
import { Invite } from '@/types/api/invite';

export const getInvite = async ({ code }: { code: string }): Promise<Invite> => {
  return (await api.get(`/invites/${code}`)).data;
};

export const getInviteQueryOptions = (code: string) => {
  return queryOptions({
    queryKey: ['invites', code],
    queryFn: () => getInvite({ code }),
    enabled: Boolean(code),
  });
};

type UseInviteOptions = {
  code: string;
  queryConfig?: QueryConfig<typeof getInviteQueryOptions>;
};

export const useInvite = ({ code, queryConfig }: UseInviteOptions) => {
  return useQuery({
    ...getInviteQueryOptions(code),
    ...queryConfig,
  });
};

export const useInviteSuspense = ({ code, queryConfig }: UseInviteOptions) => {
  return useSuspenseQuery({
    ...getInviteQueryOptions(code),
    ...queryConfig,
  });
};
